import React from 'react';

import styles from './InvestmentTeamSlide.css';
import fallbackImg from '../../images/no_photo_large.png';

const InvestmentTeamSlide = ({
    managedSince,
    name,
    headshot: { path: imgSrc = '' } = {},
    position,
    education,
    joinedDate,
    ticker
}) => {
    const showFootNoteSymbol = () => {
        if (ticker === 'TUHYX' || ticker === 'TUHIX') {
            return <sup>**</sup>;
        }
        return '';
    };

    return (
        <div className="manager">
            <figure className="profile-photo">
                <img
                    src={!imgSrc ? `${fallbackImg}` : `${imgSrc}`}
                    alt={name}
                />
                <figcaption>
                    <div className="title">{position}</div>
                    <div className="detail">Managed Fund Since:</div>
                    <div className="detail">
                        {managedSince}
                        {showFootNoteSymbol()}
                    </div>
                </figcaption>
            </figure>
            <div className="bio">
                <div className="name">
                    <div>{name}</div>
                </div>
                <div className="joined">
                    Joined T. Rowe Price on {joinedDate}
                </div>
                <div className="education">{education}</div>
            </div>
            <style jsx>{styles}</style>
        </div>
    );
};

export default InvestmentTeamSlide;
